const $755957079a54393b$export$de7ead42144ee87f = document.querySelector(":root");
function $755957079a54393b$export$71511d61b312f219(id) {
    return document.getElementById(id);
}
function $755957079a54393b$export$3d8c2f653ac9d0b9(parent, selector) {
    return Array.from(parent.querySelectorAll(selector));
}



function $a87d007122993cbf$export$2e2bcd8739ae039({ inputPass: inputPass, showPassBtn: showPassBtn }) {
    _init();
    function _init() {
        inputPass.addEventListener("focus", (e)=>{
            _onInput(e);
        });
        inputPass.addEventListener("keyup", (e)=>{
            _onInput(e);
        });
        showPassBtn.addEventListener("click", (e)=>{
            _onShowBtnClick(e);
        });
    }
    function _onInput(e) {
        const target = e.currentTarget;
        if (target.value === "") showPassBtn.classList.add("no-display");
        else showPassBtn.classList.remove("no-display");
    }
    function _onShowBtnClick(e) {
        const target = e.currentTarget;
        if (target.innerText === "SHOW") {
            target.innerText = "HIDE";
            inputPass.type = "text";
        } else {
            target.innerText = "SHOW";
            inputPass.type = "password";
        }
    }
}




class $f6e6a130867ac54c$export$2e2bcd8739ae039 {
    _overlay;
    _redirectUrl;
    _overlayBox;
    constructor(overlay, redirectUrl){
        this._overlay = overlay;
        this._redirectUrl = redirectUrl;
        this._addOnCloseListener();
        this._overlayBox = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-box")[0];
    }
    set(redirectUrl) {
        this._redirectUrl = redirectUrl;
    }
    render(content) {
        const wrapper = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-content")[0];
        wrapper.replaceChildren();
        wrapper.append(content);
        this.show();
    }
    show() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-scroll");
        this._overlay.classList.add("overlay-change");
        this._overlayBox.classList.add("overlay-box-change");
    }
    _addOnCloseListener() {
        this._overlay.addEventListener("click", (e)=>{
            this._onClose(e);
        });
    }
    _onClose(e) {
        const target = e.target;
        if (target === this._overlay) this.hide();
    }
    hide() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-scroll");
        this._overlayBox.classList.remove("overlay-box-change");
        setTimeout(()=>{
            this._overlay.classList.remove("overlay-change");
            if (this._redirectUrl) window.location.href = this._redirectUrl;
        }, 300);
    }
}


function $445d564eceaecb6d$var$makeForgotPassBtn({ forgotPassEl: forgotPassEl, forgotPassOverlay: forgotPassOverlay }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        const ForgotPassOverlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(forgotPassOverlay);
        forgotPassEl.addEventListener("click", ()=>{
            ForgotPassOverlay.show();
        });
        initialized = true;
    }
}
const $445d564eceaecb6d$var$ForgotPassBtn = $445d564eceaecb6d$var$makeForgotPassBtn({
    forgotPassEl: (0, $755957079a54393b$export$71511d61b312f219)("forgotPass"),
    forgotPassOverlay: (0, $755957079a54393b$export$71511d61b312f219)("forgotOverlay")
});
var $445d564eceaecb6d$export$2e2bcd8739ae039 = $445d564eceaecb6d$var$ForgotPassBtn;



function $58f9f437543be56c$export$2e2bcd8739ae039(actions) {
    let events = [];
    actions.forEach((action)=>{
        events.push({
            event: new CustomEvent("app-event", {
                detail: {
                    action: action
                }
            }),
            action: action
        });
    });
    return Object.freeze({
        emit: emit
    });
    function emit(action) {
        const ev = events.find((event)=>event.action === action);
        window.dispatchEvent(ev.event);
    }
}


const $6434be5183dff379$var$APP_EVENTS = (0, $58f9f437543be56c$export$2e2bcd8739ae039)([
    "forgot-pass-form-submitted",
    "login-form-submitted"
]);
var $6434be5183dff379$export$2e2bcd8739ae039 = $6434be5183dff379$var$APP_EVENTS;


function $562cb4910df9a60c$export$2e2bcd8739ae039({ form: form, submitBtn: submitBtn, preventDefault: preventDefault, events: events, action: action }) {
    let initialized = false;
    return Object.freeze({
        init: init,
        get: get
    });
    function init() {
        if (initialized) return;
        form.addEventListener("submit", (e)=>{
            if (preventDefault) e.preventDefault();
            events.emit(action);
        });
        initialized = true;
    }
    function get() {
        return {
            form: form,
            submitBtn: submitBtn
        };
    }
}


const $db6f880589c8c8a7$var$ForgotPassForm = (0, $562cb4910df9a60c$export$2e2bcd8739ae039)({
    form: (0, $755957079a54393b$export$71511d61b312f219)("forgotForm"),
    submitBtn: (0, $755957079a54393b$export$71511d61b312f219)("forgotBtn"),
    preventDefault: true,
    events: (0, $6434be5183dff379$export$2e2bcd8739ae039),
    action: "forgot-pass-form-submitted"
});
var $db6f880589c8c8a7$export$2e2bcd8739ae039 = $db6f880589c8c8a7$var$ForgotPassForm;





const $1807d9bfdfc6bc8b$var$LoginForm = (0, $562cb4910df9a60c$export$2e2bcd8739ae039)({
    form: (0, $755957079a54393b$export$71511d61b312f219)("loginForm"),
    submitBtn: (0, $755957079a54393b$export$71511d61b312f219)("loginBtn"),
    preventDefault: false,
    events: (0, $6434be5183dff379$export$2e2bcd8739ae039),
    action: "login-form-submitted"
});
var $1807d9bfdfc6bc8b$export$2e2bcd8739ae039 = $1807d9bfdfc6bc8b$var$LoginForm;



function $9c5c4c45b9fa185f$export$2e2bcd8739ae039({ btn: btn }) {
    const submitBtn = btn;
    const spinner = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, ".spinner")[0];
    const buttonSpan = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, ".btn-span")[0];
    return Object.freeze({
        reset: reset,
        onLoading: onLoading
    });
    function reset() {
        _btnLoader(false);
    }
    function onLoading() {
        _btnLoader(true);
    }
    function _btnLoader(isLoading) {
        if (isLoading) {
            submitBtn.disabled = true;
            spinner.classList.remove("no-display");
            buttonSpan.classList.add("no-display");
        } else {
            submitBtn.disabled = false;
            spinner.classList.add("no-display");
            buttonSpan.classList.remove("no-display");
        }
    }
}



function $01df58dec21e7277$export$2e2bcd8739ae039({ form: form, submitBtn: submitBtn }) {
    _preventSubmit();
    const LOADER = (0, $9c5c4c45b9fa185f$export$2e2bcd8739ae039)({
        btn: submitBtn
    });
    LOADER.onLoading();
    return Object.freeze({
        afterResponse: afterResponse
    });
    function afterResponse(resetForm) {
        _enableSubmit();
        LOADER.reset();
        if (resetForm) form?.reset();
    }
    function _preventSubmit() {
        document.addEventListener("keydown", _onPreventFormSubmit);
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-pointers");
    }
    function _enableSubmit() {
        document.removeEventListener("keydown", _onPreventFormSubmit);
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-pointers");
    }
    function _onPreventFormSubmit(e) {
        if (e.code === "Enter") e.preventDefault(); //avoid submitting form
    }
}



function $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr) {
    const el = document.createElement(tag);
    el.setAttribute("class", classes);
    if (attr) for(let key in attr)el.setAttribute(key, attr[key]);
    return el;
}
function $9eeef69b55ee9859$export$ecd10de24f44b999(tag, classes, text, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    el.innerText = text;
    return el;
}
function $9eeef69b55ee9859$export$69b2a7fcb8b634f(tag, classes, html, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    el.innerHTML = html;
    return el;
}
function $9eeef69b55ee9859$export$ee31727d4121fca7(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("img", classes, attr);
}
function $9eeef69b55ee9859$export$f235d743d35a42d0(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("audio", classes, attr);
}
function $9eeef69b55ee9859$export$c34ace1158f06c39(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("video", classes, attr);
}
function $9eeef69b55ee9859$export$258b0eb2f6f9eed2(classes, attr) {
    return $9eeef69b55ee9859$export$ecd10de24f44b999("button", classes, attr.text, attr);
}
function $9eeef69b55ee9859$export$5a1947d71e311350(classes, attr) {
    const btn = $9eeef69b55ee9859$export$3d7cd8ed57263b30("button", classes, attr);
    const spinner = $9eeef69b55ee9859$export$3d7cd8ed57263b30("div", "spinner no-display");
    const span = $9eeef69b55ee9859$export$ecd10de24f44b999("span", "btn-span", attr.text);
    btn.append(spinner, span);
    return btn;
}
function $9eeef69b55ee9859$export$407ea597bae49e98(fragments) {
    const fragment = document.createDocumentFragment();
    fragments.forEach((fr)=>fragment.append(fr));
    return fragment;
}
function $9eeef69b55ee9859$export$aefe1a6be41e3d0c(tag, classes, target, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    target.append(el);
}
function $9eeef69b55ee9859$export$e7e97c57fc2e401c(tag, classes, target, text, attr) {
    const el = $9eeef69b55ee9859$export$ecd10de24f44b999(tag, classes, text, attr);
    target.append(el);
}
function $9eeef69b55ee9859$export$87eb1d92205d639(tag, classes, target, html, attr) {
    const el = $9eeef69b55ee9859$export$69b2a7fcb8b634f(tag, classes, html, attr);
    target.append(el);
}



function $e3d294463b74ae93$export$e4dd48968eea87b5() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 50 50");
    svg.setAttribute("width", "30");
    svg.setAttribute("height", "30");
    svg.setAttribute("transform", "scale(0.7)");
    svg.innerHTML = `
        <path fill="#00bf6f"
            d="m25,0.572441c-13.489683,0 -24.427559,10.937876 -24.427559,24.427559c0,13.489683 10.937876,24.427559 24.427559,24.427559c13.489683,0 24.427559,-10.937876 24.427559,-24.427559c0,-13.489683 -10.937876,-24.427559 -24.427559,-24.427559zm12.530029,16.259594l-15.169078,19.465711c-0.119957,0.119957 -0.31625,0.381681 -0.556163,0.381681c-0.250819,0 -0.414396,-0.174483 -0.556163,-0.31625c-0.141767,-0.141767 -8.604171,-8.277017 -8.604171,-8.277017l-0.163577,-0.163577c-0.065431,-0.098146 -0.119957,-0.218103 -0.119957,-0.348965c0,-0.130862 0.054526,-0.250819 0.119957,-0.348965c0.043621,-0.043621 0.076336,-0.076336 0.119957,-0.130862c0.839697,-0.883318 2.540902,-2.671764 2.649954,-2.780816c0.141767,-0.141767 0.261724,-0.327155 0.523448,-0.327155c0.272629,0 0.447112,0.229008 0.577973,0.35987c0.130862,0.130862 4.907322,4.721934 4.907322,4.721934l12.137443,-15.594379c0.109052,-0.087241 0.239914,-0.152672 0.381681,-0.152672c0.141767,0 0.272629,0.054526 0.381681,0.141767l3.336979,2.628144c0.087241,0.109052 0.141767,0.239914 0.141767,0.381681c0.010905,0.141767 -0.043621,0.261724 -0.109052,0.35987z" />`;
    return svg;
}
function $e3d294463b74ae93$export$2b895fe12934f65() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 64 64");
    svg.setAttribute("width", "50");
    svg.setAttribute("height", "50");
    svg.innerHTML = `
        <path fill="#ff618a" d="M30.16,11.51,6.84,51.9a2.13,2.13,0,0,0,1.84,3.19H55.32a2.13,2.13,0,0,0,1.84-3.19L33.84,11.51A2.13,2.13,0,0,0,30.16,11.51Z"/>
        <path fill="#1e1f29" d="M29,46a3,3,0,1,1,3,3A2.88,2.88,0,0,1,29,46Zm1.09-4.66-.76-15h5.26l-.73,15Z"/>`;
    return svg;
}


function $bac9fd8885449360$var$makeResponse() {
    const overlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)((0, $755957079a54393b$export$71511d61b312f219)("resultOverlay"));
    return Object.freeze({
        show: show
    });
    function show({ ...args }) {
        const classes = args.resp.success ? "text-center" : "error text-center";
        const svg = args.resp.success ? (0, $e3d294463b74ae93$export$e4dd48968eea87b5)() : (0, $e3d294463b74ae93$export$2b895fe12934f65)();
        const textHTML = args.resp.success || args.resp.error ? args.respText : "A server-side error occured";
        const btnClasses = args.resp.success ? "submit-btn success-btn no-margin btns" : "submit-btn error-btn no-margin btns";
        const okBtn = (0, $9eeef69b55ee9859$export$258b0eb2f6f9eed2)(btnClasses, {
            type: "button",
            title: "OK",
            text: "OK"
        });
        const fragments = [
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("h1", classes, args.respTitle),
            svg,
            (0, $9eeef69b55ee9859$export$69b2a7fcb8b634f)("p", classes, textHTML),
            okBtn
        ];
        const fragment = (0, $9eeef69b55ee9859$export$407ea597bae49e98)(fragments);
        overlay.render(fragment);
        if (args.onRedirect) overlay.set(args.onRedirect);
        okBtn.addEventListener("click", ()=>{
            overlay.hide();
        });
    }
}
const $bac9fd8885449360$var$ServerResponse = $bac9fd8885449360$var$makeResponse();
var $bac9fd8885449360$export$2e2bcd8739ae039 = $bac9fd8885449360$var$ServerResponse;


function $6f42e8eea5ca176e$var$makeRequest() {
    return Object.freeze({
        post: post
    });
    async function post(url, payload) {
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        };
        try {
            const response = await fetch(url, options);
            return await response.json();
        } catch (err) {
            console.error(err);
            return {
                success: false,
                error: "An unexpected error occured<br><br>Please check your internet connection"
            };
        }
    }
}
const $6f42e8eea5ca176e$var$Request = $6f42e8eea5ca176e$var$makeRequest();
var $6f42e8eea5ca176e$export$2e2bcd8739ae039 = $6f42e8eea5ca176e$var$Request;



var $79e9979115d99da8$export$2e2bcd8739ae039 = {
    execute: async ()=>{
        const { form: form, submitBtn: submitBtn } = (0, $db6f880589c8c8a7$export$2e2bcd8739ae039).get();
        const payload = {
            email: form.email.value.trim().toLowerCase()
        };
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/forgot-pass", payload);
        formRequest.afterResponse(true);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `An email with a password reset link has been sent to the following address:<br><br><strong><u>${response.email}</u></strong>`,
                onRedirect: "/"
            });
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};




var $4ff61b90b51c002b$export$2e2bcd8739ae039 = {
    execute: async ()=>{
        const { form: form, submitBtn: submitBtn } = (0, $1807d9bfdfc6bc8b$export$2e2bcd8739ae039).get();
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
    }
};


function $9880b6e1b047bdfc$var$makeEventRouter() {
    const router = {
        "forgot-pass-form-submitted": (0, $79e9979115d99da8$export$2e2bcd8739ae039),
        "login-form-submitted": (0, $4ff61b90b51c002b$export$2e2bcd8739ae039)
    };
    return Object.freeze({
        get: get
    });
    function get(action) {
        return router[action];
    }
}
const $9880b6e1b047bdfc$var$APP_VIEWS = $9880b6e1b047bdfc$var$makeEventRouter();
var $9880b6e1b047bdfc$export$2e2bcd8739ae039 = $9880b6e1b047bdfc$var$APP_VIEWS;


function $61dd612681b64924$export$2e2bcd8739ae039({ inputPass: inputPass, showPassBtn: showPassBtn }) {
    _initAppShell();
    return Object.freeze({
        resize: resize,
        executeEvent: executeEvent
    });
    function _initAppShell() {
        (0, $a87d007122993cbf$export$2e2bcd8739ae039)({
            inputPass: inputPass,
            showPassBtn: showPassBtn
        });
        (0, $445d564eceaecb6d$export$2e2bcd8739ae039).init();
        (0, $db6f880589c8c8a7$export$2e2bcd8739ae039).init();
        (0, $1807d9bfdfc6bc8b$export$2e2bcd8739ae039).init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = (0, $9880b6e1b047bdfc$export$2e2bcd8739ae039).get(action);
        await view.execute();
    }
}


(async function() {
    const overlays = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".overlay");
    overlays.forEach((overlay)=>overlay.classList.remove("no-display"));
    const app = (0, $61dd612681b64924$export$2e2bcd8739ae039)({
        inputPass: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".input-pass")[0],
        showPassBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".show-btn")[0]
    });
    window.addEventListener("resize", app.resize);
    app.resize();
    window.addEventListener("app-event", (e)=>{
        app.executeEvent(e.detail.action);
    });
    document.documentElement.addEventListener("touchstart", function(e) {}); //hover behaviour on touch devices
})();


//# sourceMappingURL=login.ed919bcc.js.map
